<template>
  <div v-if="helpModeEnabled" class="help-hint-badge" :style="badgeStyle" @click.stop="menuOpen = true">
    <q-icon :name="icon" size="12px" color="white" />
    <q-menu
      v-model="menuOpen"
      no-parent-event
      anchor="top middle"
      self="bottom middle"
      :offset="[0, 8]"
    >
      <q-card flat class="q-pa-sm" style="max-width: 220px">
        <div v-if="label" class="text-weight-bold text-caption q-mb-xs">{{ label }}</div>
        <div class="text-caption">{{ text }}</div>
      </q-card>
    </q-menu>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ref } from 'vue'
import { useHelpMode } from 'src/composables/useHelpMode'

const props = withDefaults(
  defineProps<{
    text: string
    label?: string
    icon?: string
    top?: string
    right?: string
    bottom?: string
    left?: string
  }>(),
  { icon: 'help' },
)

const { helpModeEnabled } = useHelpMode()
const menuOpen = ref(false)

const badgeStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.top) style.top = props.top
  if (props.left) style.left = props.left
  if (props.right) style.right = props.right
  if (props.bottom) style.bottom = props.bottom

  // Fallback position (top-right corner) when caller supplies no coordinates —
  // used for the inline "badge on a DOM button" case.
  if (!props.top && !props.left && !props.right && !props.bottom) {
    style.top = '-6px'
    style.right = '-6px'
  }
  return style
})
</script>

<style scoped>
.help-hint-badge {
  position: absolute;
  z-index: 200;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--q-primary);
  border: 1.5px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
</style>
